import axios from 'axios'
const state = {
    loading: false,
    loadingCom: false,
    salers: [],
    communication: [],
    payment: null,
    notes: {
        tableHeaders: [],
        tableData: [],
        accessTableData: [],
        loading: false,
        tableMeta: {
            total: 10,
            page: 1,
        },
    },
    saler: {
        data: {},
        id: null,
        name: null,
        image: null,
        account: null,
        user: null,
        communications: null,
        information: {
          code: {
            desc: "Barcode",
            value: "",
          },
          tax_number: {
            desc:"Tax Number",
            value:""
          },
          type: {
            desc:"Type",
            value:""
          },
          phone: {
            desc: "hr.employee.phone",
            value: "",
          },
          email: {
            desc: "hr.employee.email",
            value: "",
          },
          classification: {
            desc: "Classification",
            value: "",
          },
          mobile: {
            desc: "hr.employee.phone2",
            value: "",
          },
          address: {
            desc: "address",
            value: "",
          },
          group: {
            desc: "Group",
            value: "",
          },
          coin: {
            desc: "Currency",
            value: "",
          },
        }
    },
    tableOptions: {
        tableHeaders: [],
        tableData: [],
        accessTableData: [],
        loading: false,
        tableMeta: {
            total: 20,
            page: 1,
            per_page: 20,
        },
    }
};
const getters = {
    getLoadingStatus(state) {
        return state.loading;
    },
    getLoadingCom(state) {
        return state.loadingCom;
    },
    getSaler(state) {
        return state.saler
    },
    getSalers(state) {
        return state.salers
    },
    getTableOptions(state) {
        return state.tableOptions
    },
    getCommunication(state) {
        return state.communication
    },
    getPayment(state) {
        return state.payment
    },
    getNotes(state) {
        return state.notes
    },
};

const mutations = {
    setLoadingStatus(state, status) {
        state.loading = status;
    },
    setLoadingCom(state, status) {
        state.loadingCom = status;
    },
    setCommunication(state, communication) {
        state.communication = communication;
    },
    setSaler(state, saler) {
        state.saler.data = saler;
        state.saler.id = saler.id;
        state.saler.name = saler.name;
        state.saler.image = saler.image;
        state.saler.communications = saler.communications;
        state.saler.account = saler.account;
        state.saler.user = saler.user;
        state.saler.information.code.value = saler.code;
        state.saler.information.tax_number.value = saler.tax_number;
        state.saler.information.type.value = saler.type;
        state.saler.information.phone.value = saler.phone;
        state.saler.information.email.value = saler.email;
        state.saler.information.classification.value = saler.classification;
        state.saler.information.mobile.value = saler.mobile;
        state.saler.information.address.value = saler.address;
        state.saler.information.group.value = saler.group.name;
        state.saler.information.coin.value = saler.coin.name;
    },
    setSalers(state, salers) {
        state.salers = salers
    },
    setLoading(state, status) {
        state.tableOptions.loading = status
        state.notes.loading = status
    },
    setTableData(state, tableInfo) {
        state.tableOptions.tableHeaders = tableInfo.tableHeaders
        state.tableOptions.tableData = tableInfo.tableData
        state.tableOptions.accessTableData = tableInfo.accessTableData
        state.tableOptions.tableMeta.total = tableInfo.tableMeta.total
        state.tableOptions.tableMeta.page = tableInfo.tableMeta.page
    },
    setNotes(state, tableInfo) {
        state.notes.tableHeaders = tableInfo.tableHeaders
        state.notes.tableData = tableInfo.tableData
        state.notes.accessTableData = tableInfo.accessTableData
        state.notes.tableMeta.total = tableInfo.tableMeta.total
        state.notes.tableMeta.page = tableInfo.tableMeta.page
    },
};

const actions = {
    async fetchSalers({ commit }, queryParams) {
        try {
            commit('setLoading', true)
            let params = {};
            for (let key in queryParams) {
                if (queryParams[key]) {
                    params[key] = queryParams[key];
                }
            }
            if(!queryParams.paginated) params.paginated = queryParams.paginated;
            const response = await axios.get("/b2b/saler", {
                params,
            });
            let custo = response.data.data.map((el)=>{return{...el,isMyCusto: false}})
            commit('setSalers', response.data.data)
            commit('setTableData', {
                tableHeaders: params.checkcheck == 'true' ?  [
                    "name",
                    "hr.employee.phone",
                    "Zone",
                    "Group Name",
                    "Type",
                    "check",
                ] :  [
                    "name",
                    "hr.employee.phone",
                    "Zone",
                    "Group Name",
                    "Type",
                    "settings",
                ],
                tableData: custo,
                accessTableData: [
                    ["name"],
                    ["phone"],
                    ["zone","name"],
                    ["group","name"],
                    ["type"],
                ],
                tableMeta: {
                    total: response.data.meta.total,
                    page: response.data.meta.current_page,
                    per_page: response.data.meta.per_page,
                },
            })
        } catch (err) {
            console.log('err', err);
        } finally {
            commit('setLoading', false)
        }
    },
   
    async fetchSaler({ commit }, id) {
        try {
            commit('setLoadingStatus', true)
            const response = await axios.get(`/b2b/saler/${id}`);
            commit('setSaler', response.data.data)
        } catch (err) {
            console.log('err', err);
        } finally {
            commit('setLoadingStatus', false)
        }
    },
    async fetchCommunication({ commit }, id) {
        try {
            commit('setLoadingCom', true)
            const response = await axios.get(`/b2b/saler/${id}/communication`);
            commit('setCommunication', response.data.data)
        } catch (err) {
            console.log('err', err);
        } finally {
            commit('setLoadingCom', false)
        }
    },
    async fetchPayments({ commit }, id) {
        try {
            commit('setLoadingStatus', true)
            const response = await axios.get(`/b2b/saler/${id}/payment`);
            state.payment = response.data.data;
        } catch (err) {
            console.log('err', err);
        } finally {
            commit('setLoadingStatus', false)
        }
    },
    async fetchNotes({ commit }, queryParams) {
        try {
            commit('setLoadingStatus', true)
            let params = {};
            for (let key in queryParams) {
                if (queryParams[key]) {
                    params[key] = queryParams[key];
                }
            }
            if(!queryParams.paginated) params.paginated = queryParams.paginated;
            const response = await axios.get(`/b2b/saler/${params.cuId}/note`,{
                params,
            });
            commit('setNotes', {
                tableHeaders: [
                    "date",
                    "title",
                    "Note",
                    "user name",
                    "settings",
                ],
                tableData: response.data.data,
                accessTableData: [
                    ["created_at"],
                    ["title"],
                    ["note"],
                    ["user"],
                ],
                tableMeta: {
                    total: 10, //response.data.meta.total,
                    page: 1, //response.data.meta.current_page,
                },
            })
        } catch (err) {
            console.log('err', err);
        } finally {
            commit('setLoadingStatus', false)
        }
    },
    postNewSaler({ commit }, newSaler) {
        return new Promise(async (resolve, reject) => {
            try {
                let form = new FormData();
                for (let key in newSaler) {
                    if (newSaler[key]) {
                        form.append(`${key}`, newSaler[key])
                    }
                }
                newSaler.id ? await axios.post(`/b2b/saler/${newSaler.id}`, form) : await axios.post("/b2b/saler", form);
                resolve()
            }
            catch (err) {
                reject()
            }
        })
    },
}

export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true
}